import { render } from "./NavigationDrawerMenu.vue?vue&type=template&id=0b487424"
import script from "./NavigationDrawerMenu.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerMenu.vue?vue&type=script&lang=js"

import "./NavigationDrawerMenu.vue?vue&type=style&index=0&id=0b487424&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__